// Chart utils compartidos: tooltip HTML, eje X (mes) y eje Y (montos
// compactos). Antes había 3 copias del row del tooltip y 2 formatters de eje
// Y ("Q0k" roto en el dashboard vs el refinado del cliente 360).
import type { GlobalToken } from 'antd';
import { CURRENCY_LOCALE, formatCurrency, getCurrencySymbol } from './format';

const COMPACT_FORMATTER = new Intl.NumberFormat(CURRENCY_LOCALE, {
  maximumFractionDigits: 1,
});

/** Full compact number under the app locale (e.g. 590 → "590", 1.25 → "1,3"). */
function compact(value: number): string {
  return COMPACT_FORMATTER.format(value);
}

/**
 * Y-axis tick label: full amount below 1k, "k" for thousands, "M" for
 * millions — always prefixed with the currency symbol. Honesto en cualquier
 * escala: montos chicos completos ("Q150") en vez del "Q0k" roto.
 */
export function formatYAxisCompact(value: number, symbol: string = getCurrencySymbol()): string {
  const abs = Math.abs(value);
  if (abs >= 1_000_000) return `${symbol}${compact(value / 1_000_000)}M`;
  if (abs >= 1_000) return `${symbol}${compact(value / 1_000)}k`;
  return `${symbol}${Math.round(value).toLocaleString(CURRENCY_LOCALE)}`;
}

/**
 * X-axis tick label for a `YYYY-MM` bucket: short month + year ("mar 26").
 * The year is required once the range spans more than one calendar year.
 */
export function monthAxisLabel(mes: string): string {
  try {
    return new Intl.DateTimeFormat(CURRENCY_LOCALE, { month: 'short', year: '2-digit' }).format(
      new Date(`${mes}-01T00:00:00`),
    );
  } catch {
    return mes;
  }
}

/** One row of the shared tooltip HTML: color dot + name + formatted value. */
export function tooltipRowHTML(
  name: string,
  value: number,
  color: string,
  token: GlobalToken,
): string {
  return `
  <div style="display:flex;align-items:center;justify-content:space-between;gap:16px;margin:4px 0;">
    <span style="display:inline-flex;align-items:center;gap:6px;color:${token.colorTextSecondary};font-size:12px;">
      <span style="display:inline-block;width:8px;height:8px;border-radius:2px;background:${color};"></span>${name}
    </span>
    <strong style="color:${token.colorText};font-variant-numeric:tabular-nums;font-size:12px;">${formatCurrency(Math.abs(value).toFixed(2))}</strong>
  </div>`;
}
